export const ConfigConstants = {
  BKS_ACCOUNT_URL: '/EBAN_Accounts_ENS/channel.ssobto?dse_operationName=MyAccounts',
  MY_ACCOUNT_TRANSSACTION: 'My Accounts & Transactions',
  CONTACT_US: 'Contact us',
  RIGHT_ARROW: 'right arrow',
  RIGHT_ARROW_IMG_PATH: 'assets/img/right-arrow-icon.png',
  CAHOOT_RIGHT_ARROW_IMG_PATH: 'assets/cahoot/right-arrow-icon.png',
  CALL_US_EXPAND_SYMBOL: 'expand symbol',
  CALL_US_COLLAPSE_SYMBOL: 'collapse symbol',
  CALL_US_PHONE_NUMBER_LINK: '<a class="phone-number" href="tel: 0330 9 123 123">0330 9 123 123</a>',
  ONLINE_BANKING_TITLE: 'Online Banking',
  CALL_US_PHONE_NUMBER_LINK1: '<a class="phone-number" href="tel: 0330 123 0209">0330 123 0209</a>',
  EIGHT_AM_EIGHT_PM_MONDAY_TO_FRIDAY: '8am - 8pm (Monday to Friday)',
  LOST_OR_STOLEN: 'Lost or stolen cards',
  LINES_OPEN_7DAYS_WEEK: 'Lines open 24 hours 7 days a week',
  ONE_TIME_PASSCODE: 'One Time Passcode',
  EIGHT_AM_FIVE_PM_MONDAY_TO_FRIDAY: '8am - 5pm (Monday to Friday)',
  CLOSED_SUNDAY: 'Closed (Sunday)',
  EIGHT_AM_EIGHT_PM_SATURDAY_TO_SUNDAY: '8am - 6pm (Saturday to Sunday)',
  EIGHT_AM_SEVEN_PM_MONDAY_TO_FRIDAY: '8am - 7pm (Monday to Friday)',
  EIGHT_AM_SIX_PM_MONDAY_TO_FRIDAY: '8am - 6pm (Monday to Friday)',
  CAHOOT_PHONE_NUMBER: '<a class="cahoot-phone-number" href="tel: 0330 678 2811">0330 678 2811</a>',
  NINE_AM_SIX_PM_MONDAY_TO_FRIDAY: '9am - 6pm (Monday to Friday)',
  NINE_AM_TWO_PM_SATURDAY: '9am - 2pm (Saturday)',
};
export const applicationContentConfig = {
  logOff:
    '/EBAN_Accounts_ENS/channel.ssobto?dse_operationName=contentTemplate&iurl=%2FLOGSUK_S_ENS%2Fchannel.ssobto%3Fdse_operationName%3DLOGOFF&lang=en-GB&opCode=00000098&layout=transaction',
  logOffBlockCredential: '/logoff',
  externalSantanderLogoff: 'https://www.santander.co.uk/logoff',
  externalCahootLogOffUrl: 'https://secure.cahoot.com/LOGSUK_S_ENS/channel.ssobto?dse_operationName=LOGOFF_FALCON',
  revokeSessionUrl: '/olb/app/authenticator/revoke-session?domain={{domain}}',
  bksErrorPage:
    '/EBAN_Accounts_ENS/channel.ssobto?dse_operationName=ErrorHandler&opCode=00000001',
  bksAccountUrl:
    ConfigConstants.BKS_ACCOUNT_URL,
  contactUsUrl: '/olb/app/contact-us/',
  headerUrls: {
    logo: {
      authOnLink: {
        text: ConfigConstants.MY_ACCOUNT_TRANSSACTION,
        title: 'Santander My Account Home',
        url: ConfigConstants.BKS_ACCOUNT_URL,
      },
    },
    links: [
      {
        authOnLink: {
          text: 'Accounts',
          title: ConfigConstants.MY_ACCOUNT_TRANSSACTION,
          url: ConfigConstants.BKS_ACCOUNT_URL,
        },
      },
      {
        authOnLink: {
          text: ConfigConstants.CONTACT_US,
          title: ConfigConstants.CONTACT_US,
          url: '/olb/app/contact-us/',
        },
      },
      {
        authOnLink: {
          text: 'Log off',
          title: 'Log off',
          url: 'https://www.santander.co.uk/logoff',
        },
      },
    ],
  },

  // QUICK LINKS
  QUICK_LINK_ONE: {
    label: 'Lost and stolen cards',
    id: 'lostStolenQuickLink',
    url: 'lostStolenChat',
    rightIcon: {
      name: 'chat',
      src: 'assets/img/chat-icon.png',
      style: { width: '24px' },
    },
  },
  QUICK_LINK_TWO: {
    label: 'Close my account',
    id: 'closeAccountQuickLink',
    url: 'closeAccountChat',
    rightIcon: {
      name: 'chat',
      src: 'assets/img/chat-icon.png',
      style: { width: '24px' },
    },
  },
  QUICK_LINK_THREE: {
    label: 'Set up new payment',
    id: 'snpQuickLink',
    url: '/olb/app/payments/movemoney/#/account-selection',
    rightIcon: {
      name: ConfigConstants.RIGHT_ARROW,
      src: ConfigConstants.RIGHT_ARROW_IMG_PATH,
      style: { width: '10px' },
    },
  },
  QUICK_LINK_FOUR: {
    label: 'Change address',
    id: 'changeAddressQuickLink',
    url: '/EBAN_ServiceRequest_ENS/BtoChannelDriver.ssobto?dse_operationName=Change_Address',
    rightIcon: {
      name: ConfigConstants.RIGHT_ARROW,
      src: ConfigConstants.RIGHT_ARROW_IMG_PATH,
      style: { width: '10px' },
    },
  },
  QUICK_LINK_FIVE: {
    label: 'Change contact details',
    id: 'changeContactQuickLink',
    url: '/EBAN_ServiceRequest_ENS/BtoChannelDriver.ssobto?dse_operationName=ChangeContactDetails',
    rightIcon: {
      name: ConfigConstants.RIGHT_ARROW,
      src: ConfigConstants.RIGHT_ARROW_IMG_PATH,
      style: { width: '10px' },
    },
  },
  QUICK_LINK_SIX: {
    label: 'View secure messages',
    id: 'viewMessagesQuickLink',
    url: '/EBAN_Accounts_ENS/BtoChannelDriver.ssobto?dse_operationName=CheckForErrors&opCode=00000059&url=%2FEBAN_Accounts_ENS%2Fchannel.ssobto%3Fdse_operationName%3DcontentTemplate%26opCode%3D00000059%26iurl%3D%252FMSEABB_ENS%252Fchannel.ssobto%253Fdse_operationName%253DOP_SecureMessages%2526obtenerMensaje_E.esContactUs%253DN',
    rightIcon: {
      name: ConfigConstants.RIGHT_ARROW,
      src: ConfigConstants.RIGHT_ARROW_IMG_PATH,
      style: { width: '10px' },
    },
  },

  // Quick link for Cahoot
  CAHOOT_QUICK_LINK_ONE: {
    label: 'Send secure message',
    id: 'sendSecureQuickLink',
    url: '/EBAN_Accounts_ENS/channel.ssobto?dse_operationName=contentTemplate&opCode=00000078&iurl=%2FMSEABB_ENS%2Fchannel.ssobto%3Fdse_operationName%3DOP_SecureMessages%26obtenerMensaje_E.esContactUs%3DS',
    rightIcon: {
      name: ConfigConstants.RIGHT_ARROW,
      src: ConfigConstants.CAHOOT_RIGHT_ARROW_IMG_PATH,
      style: {
        width: '8px',
        'margin-right': '3px',
        'margin-top': '3px',
      },
    },
  },

  CAHOOT_QUICK_LINK_TWO: {
    label: 'Set up new payment',
    id: 'snpQuickLink',
    url: '/EBAN_Payees_ENS/channel.ssobto?dse_operationName=setUpNewPayment',
    rightIcon: {
      name: ConfigConstants.RIGHT_ARROW,
      src: ConfigConstants.CAHOOT_RIGHT_ARROW_IMG_PATH,
      style: {
        width: '8px',
        'margin-right': '3px',
        'margin-top': '3px',
      },
    },
  },
  CAHOOT_QUICK_LINK_THREE: {
    label: 'Change address',
    id: 'changeAddressQuickLink',
    url: '/EBAN_ServiceRequest_ENS/BtoChannelDriver.ssobto?dse_operationName=Change_Address',
    rightIcon: {
      name: ConfigConstants.RIGHT_ARROW,
      src: ConfigConstants.CAHOOT_RIGHT_ARROW_IMG_PATH,
      style: {
        width: '8px',
        'margin-right': '3px',
        'margin-top': '3px',
      },
    },
  },
  CAHOOT_QUICK_LINK_FOUR: {
    label: 'Change contact details',
    id: 'changeContactQuickLink',
    url: '/EBAN_ServiceRequest_ENS/BtoChannelDriver.ssobto?dse_operationName=ChangeContactDetails',
    rightIcon: {
      name: ConfigConstants.RIGHT_ARROW,
      src: ConfigConstants.CAHOOT_RIGHT_ARROW_IMG_PATH,
      style: {
        width: '8px',
        'margin-right': '3px',
        'margin-top': '3px',
      },
    },
  },
  CAHOOT_QUICK_LINK_FIVE: {
    label: 'View secure messages',
    id: 'viewMessagesQuickLink',
    url: '/EBAN_Accounts_ENS/BtoChannelDriver.ssobto?dse_operationName=CheckForErrors&opCode=00000059&url=%2FEBAN_Accounts_ENS%2Fchannel.ssobto%3Fdse_operationName%3DcontentTemplate%26opCode%3D00000059%26iurl%3D%252FMSEABB_ENS%252Fchannel.ssobto%253Fdse_operationName%253DOP_SecureMessages%2526obtenerMensaje_E.esContactUs%253DN',
    rightIcon: {
      name: ConfigConstants.RIGHT_ARROW,
      src: ConfigConstants.CAHOOT_RIGHT_ARROW_IMG_PATH,
      style: {
        width: '8px',
        'margin-right': '3px',
        'margin-top': '3px',
      },
    },
  },

  // CALL US BOX
  CALL_US_BOX_RETAIL: {
    label: 'Call us',
    id: 'callUsBox',
    rightIcon: {
      name: ConfigConstants.CALL_US_EXPAND_SYMBOL,
      src: 'assets/img/expand-symbol.png',
      style: {
        width: '22px',
        'margin-right': '3px',
        'margin-top': '3px',
      },
    },
    expandedRightIcon: {
      name: ConfigConstants.CALL_US_COLLAPSE_SYMBOL,
      src: 'assets/img/collapse-symbol.png',
      style: {
        width: '22px',
        'margin-right': '3px',
        'margin-top': '3px',
      },
    },
    content: [
      {
        title: 'Managing your account',
        id: 'manageAccountContact',
        details: [
          {
            lineOne:
              ConfigConstants.CALL_US_PHONE_NUMBER_LINK,
            lineTwo: '8am - 6pm (Monday to Sunday)'
          },
        ],
      },
      {
        title: ConfigConstants.ONLINE_BANKING_TITLE,
        id: 'onlineBankingContact',
        details: [
          {
            lineOne:
              ConfigConstants.CALL_US_PHONE_NUMBER_LINK1,
            lineTwo: ConfigConstants.EIGHT_AM_EIGHT_PM_MONDAY_TO_FRIDAY,
            lineThree: '8am - 6pm (Saturday)',
            lineFour: '9am - 6pm (Sunday)',
          },
        ],
      },
      {
        title: ConfigConstants.LOST_OR_STOLEN,
        id: 'lostStolenContact',
        details: [
          {
            lineOne:
              '<a class="phone-number" href="tel: 0330 9 123 123">0330 9 123 123</a> <br> <a class="phone-number" href="tel: 0800 313 4321">0800 313 4321</a>',
            lineTwo: ConfigConstants.LINES_OPEN_7DAYS_WEEK,
            lineThree: '<a class="abroad-tooltip" tabindex="0">Calling from abroad?<span class="abroad-tooltip-text"><span class="abroad-tooltip-number">+44 1908 237 963 (Debit card)</span><br><span class="abroad-tooltip-number">+44 1512 648 725 (Credit card)</span><br><span class="abroad-tooltip-info">Call charges may apply.</span></span></a>',
          }
        ],
      },
      {
        title: ConfigConstants.ONE_TIME_PASSCODE,
        id: 'otpContact',
        details: [
          {
            lineOne:
              ConfigConstants.CALL_US_PHONE_NUMBER_LINK1,
            lineTwo: ConfigConstants.EIGHT_AM_EIGHT_PM_MONDAY_TO_FRIDAY,
            lineThree: ConfigConstants.EIGHT_AM_EIGHT_PM_SATURDAY_TO_SUNDAY,
          },
        ],
      },
      {
        title: 'Loans',
        id: 'loansContact',
        details: [
          {
            lineOne:
              '<a class="phone-number" href="tel: 0800 876 6386">0800 876 6386</a>',
              lineTwo: ConfigConstants.EIGHT_AM_SIX_PM_MONDAY_TO_FRIDAY,
              lineThree: ConfigConstants.NINE_AM_TWO_PM_SATURDAY,
              lineFour: ConfigConstants.CLOSED_SUNDAY,
          },
        ],
      },
      {
        title: 'Mortgages',
        id: 'mortgagesContact',
        details: [
          {
            lineOne:
              '<a class="phone-number" href="tel: 0800 917 5630">0800 917 5630</a>',
              lineTwo: ConfigConstants.NINE_AM_SIX_PM_MONDAY_TO_FRIDAY,
              lineThree: ConfigConstants.NINE_AM_TWO_PM_SATURDAY,
              lineFour: ConfigConstants.CLOSED_SUNDAY,
          },
        ],
      },
      {
        title: 'Investments',
        id: 'investmentsContact',
        details: [
          {
            lineOne:
              '<a class="phone-number" href="tel: 0800 328 1328">0800 328 1328</a>',
              lineTwo: ConfigConstants.EIGHT_AM_FIVE_PM_MONDAY_TO_FRIDAY,
              lineThree: 'Closed (Saturday to Sunday)',
          },
        ],
      },
      {
        other:
          '<p class="other-queries">For Insurance or any other queries, please <a href="https://www.santander.co.uk/personal/support/contact-us" aria-label="Click here for insurance or any other queries" target="_blank" rel="noreferrer noopener">click here</a></p>',
        id: 'otherContact',
      },
    ],
  },

  CALL_US_MANAGING_ACCOUNT_PRIVATE: {
    lineOne:
      '<a class="phone-number" href="tel: 0330 678 1507">0330 678 1507</a>',
    lineTwo: ConfigConstants.LINES_OPEN_7DAYS_WEEK,
    lineThree: '<a class="abroad-tooltip" tabindex="0">Calling from abroad?<span class="abroad-tooltip-text"><span class="abroad-tooltip-number">+44 151 966 6048</span><br><span class="abroad-tooltip-info">Call charges may apply.</span></span></a>',
  },
  CALL_US_MANAGING_ACCOUNT_SELECT: {
    lineOne:
      '<a class="phone-number" href="tel: 0330 123 0061">0330 123 0061</a>',
    lineTwo: ConfigConstants.LINES_OPEN_7DAYS_WEEK,
    lineThree: '<a class="abroad-tooltip" tabindex="0">Calling from abroad?<span class="abroad-tooltip-text"><span class="abroad-tooltip-number">+44 1908 216 674</span><br><span class="abroad-tooltip-info">Call charges may apply.</span></span></a>',
  },

  // Cahoot CALL US BOX
  CALL_US_BOX_CAHOOT: {
    label: 'Call us',
    id: 'callUsBox',
    rightIcon: {
      name: ConfigConstants.CALL_US_EXPAND_SYMBOL,
      src: 'assets/cahoot/cahoot-expand-symbol.png',
      style: {
        width: '22px',
        'margin-right': '3px',
        'margin-top': '3px',
      },
    },
    expandedRightIcon: {
      name: ConfigConstants.CALL_US_COLLAPSE_SYMBOL,
      src: 'assets/cahoot/cahoot-collapse-symbol.png',
      style: {
        width: '22px',
        'margin-right': '3px',
        'margin-top': '3px',
      },
    },
    content: [

      {
        title: ConfigConstants.ONLINE_BANKING_TITLE,
        id: 'onlineBankingContact',
        details: [
          {
            lineOne:
              ConfigConstants.CAHOOT_PHONE_NUMBER,
            lineTwo: ConfigConstants.EIGHT_AM_SIX_PM_MONDAY_TO_FRIDAY,
            lineThree: '9am - 5pm (Saturday)',
            lineFour: '<a class="abroad-tooltip" tabindex="0">Calling from abroad?<span class="abroad-tooltip-text"><span class="abroad-tooltip-number">+44 1908 937 222</span><br><span class="abroad-tooltip-info">Call charges may apply.</span></span></a>',
          },
        ],
      },
      {
        title: ConfigConstants.LOST_OR_STOLEN,
        id: 'lostStolenContact',
        details: [
          {
            lineOne:
              ConfigConstants.CAHOOT_PHONE_NUMBER,
            lineTwo: ConfigConstants.LINES_OPEN_7DAYS_WEEK,
          }, {
            lineOne:
              '<a class="cahoot-phone-number" href="tel: 0800 587 1111">0800 587 1111</a>',
            lineTwo: '<a class="abroad-tooltip" tabindex="0">Calling from abroad?<span class="abroad-tooltip-text"><span class="abroad-tooltip-number">+44 1908 937 222</span><br><span class="abroad-tooltip-info">Call charges may apply.</span></span></a>',
          },
        ],
      },
      {
        title: ConfigConstants.ONE_TIME_PASSCODE,
        id: 'otpContact',
        details: [
          {
            lineOne:
              ConfigConstants.CAHOOT_PHONE_NUMBER,
            lineTwo: ConfigConstants.EIGHT_AM_SIX_PM_MONDAY_TO_FRIDAY,
            lineThree: '9am - 5pm (Saturday)',
          },
        ],
      },
    ],
  },

  CALL_US_BOX_SBBI: {
    label: 'Call us',
    id: 'callUsBox',
    rightIcon: {
      name: ConfigConstants.CALL_US_EXPAND_SYMBOL,
      src: 'assets/img/expand-symbol.png',
      style: {
        width: '22px',
        'margin-right': '3px',
        'margin-top': '3px',
      },
    },
    expandedRightIcon: {
      name: ConfigConstants.CALL_US_COLLAPSE_SYMBOL,
      src: 'assets/img/collapse-symbol.png',
      style: {
        width: '28px',
      },
    },
    content: [
      {
        title: 'Managing your account',
        id: 'manageAccountContact',
        details: [
          {
            subTitle: 'Business',
            lineOne:
              '<a class="phone-number" href="tel: 0800 731 6666">0800 731 6666</a>',
            lineTwo: ConfigConstants.EIGHT_AM_EIGHT_PM_MONDAY_TO_FRIDAY,
            lineThree: '8am - 2pm (Saturday)',
          },
          {
            subTitle: 'Personal',
            lineOne:
              ConfigConstants.CALL_US_PHONE_NUMBER_LINK,
            lineTwo: '8am - 6pm (Monday to Sunday)',
          },
        ],
      },
      {
        title: ConfigConstants.ONLINE_BANKING_TITLE,
        id: 'onlineBankingContact',
        details: [
          {
            subTitle: 'Business',
            lineOne:
              '<a class="phone-number" href="tel: 0800 169 6677">0800 169 6677</a>',
            lineTwo: ConfigConstants.EIGHT_AM_EIGHT_PM_MONDAY_TO_FRIDAY,
            lineThree: '8am - 2pm (Saturday)',
          },
          {
            subTitle: 'Personal',
            lineOne:
              ConfigConstants.CALL_US_PHONE_NUMBER_LINK1,
            lineTwo: ConfigConstants.EIGHT_AM_EIGHT_PM_MONDAY_TO_FRIDAY,
            lineThree: '8am - 6pm (Saturday)',
            lineFour: '9am - 6pm (Sunday)',
          },
        ],
      },
      {
        title: ConfigConstants.LOST_OR_STOLEN,
        id: 'lostStolenContact',
        details: [
          {
            subTitle: 'Business',
            lineOne:
              '<a class="phone-number" href="tel: 0800 731 6666">0800 731 6666</a>',
            lineTwo: ConfigConstants.LINES_OPEN_7DAYS_WEEK,
          },
          {
            subTitle: 'Personal',
            lineOne:
              ConfigConstants.CALL_US_PHONE_NUMBER_LINK,
            lineTwo: ConfigConstants.LINES_OPEN_7DAYS_WEEK,
            lineThree:
              '<a class="abroad-tooltip" tabindex="0">Calling from abroad?<span class="abroad-tooltip-text">+44 1908 237 968 (Debit & Credit Cards) \n Call charges may apply.</span></a>',
            // link: {
            //   name: 'Calling from abroad?',
            //   url: 'www.google.co.uk',
            // },
          },
        ],
      },
      {
        title: ConfigConstants.ONE_TIME_PASSCODE,
        id: 'otpContact',
        details: [
          {
            lineOne:
              ConfigConstants.CALL_US_PHONE_NUMBER_LINK1,
            lineTwo: ConfigConstants.EIGHT_AM_EIGHT_PM_MONDAY_TO_FRIDAY,
            lineThree: ConfigConstants.EIGHT_AM_EIGHT_PM_SATURDAY_TO_SUNDAY,
          },
        ],
      },
      {
        title: 'Loans',
        id: 'loansContact',
        details: [
          {
            subTitle: 'Business',
            lineOne:
              '<a class="phone-number" href="tel: 0800 313 4482">0800 313 4482</a>',
            lineTwo: ConfigConstants.EIGHT_AM_SIX_PM_MONDAY_TO_FRIDAY,
          },
          {
            subTitle: 'Personal',
            lineOne:
              '<a class="phone-number" href="tel: 0800 876 6386">0800 876 6386</a>',
              lineTwo: ConfigConstants.EIGHT_AM_SIX_PM_MONDAY_TO_FRIDAY,
              lineThree: ConfigConstants.NINE_AM_TWO_PM_SATURDAY,
              lineFour: ConfigConstants.CLOSED_SUNDAY,
          },
        ],
      },
      {
        title: 'Business credit cards',
        id: 'sbbiCreditContact',
        details: [
          {
            lineOne:
              '<a class="phone-number" href="tel: 0800 218 2345">0800 218 2345</a>',
            lineTwo: ConfigConstants.EIGHT_AM_EIGHT_PM_MONDAY_TO_FRIDAY,
            lineThree: ConfigConstants.EIGHT_AM_EIGHT_PM_SATURDAY_TO_SUNDAY,
          },
        ],
      },
      {
        title: 'Mortgages',
        id: 'mortgagesContact',
        details: [
          {
            lineOne:
              '<a class="phone-number" href="tel: 0800 917 5630">0800 917 5630</a>',
              lineTwo: ConfigConstants.NINE_AM_SIX_PM_MONDAY_TO_FRIDAY,
              lineThree: ConfigConstants.NINE_AM_TWO_PM_SATURDAY,
              lineFour: ConfigConstants.CLOSED_SUNDAY,
          },
        ],
      },
      {
        title: 'Investments',
        id: 'investmentsContact',
        details: [
          {
            lineOne:
              '<a class="phone-number" href="tel: 0800 328 1328">0800 328 1328</a>',
            lineTwo: ConfigConstants.EIGHT_AM_FIVE_PM_MONDAY_TO_FRIDAY,
              lineThree: 'Closed (Saturday to Sunday)',
          },
        ],
      },
      {
        other:
          '<p class="other-queries">For Insurance or any other queries, please <a href="https://www.santander.co.uk/personal/support/contact-us" aria-label="Click here for insurance or any other queries" target="_blank" rel="noreferrer noopener">click here</a></p>',
        id: 'otherContact',
      },
    ],
  },
};

export const externalRoutes = {
  ONLINE_BANKING_GUARANTEE:
    '/personal/support/ways-to-bank/online-and-mobile-banking-commitment',
  SITE_HELP_AND_ACCESIBILITY:
    '/personal/support/customer-support/accessibility',
  SECURITY_AND_PRIVACY: '/personal/support/customer-support/legal-information',
  TERMS_AND_CONDITION:
    '/personal/support/ways-to-bank/online-banking-service-terms-conditions',
  LEGAL: '/personal/support/customer-support/legal-information',
};


export const externalCahootRoutes = {
  ONLINE_BANKING_GUARANTEE: '/guarantee/guarantee.html',
  SITE_HELP_AND_ACCESIBILITY: '/accessibility/accessibility.html',
  SECURITY_AND_PRIVACY: '/security/security_and_privacy.html',
  TERMS_AND_CONDITION: '/terms/terms_and_conditions.html',
  LEGAL: '/legal/legal.html'
};
